import { Box, Button, styled } from "@mui/material";
import { BaseMatchState, GAME_TYPE, MATCH_STATE } from "../../types/match";
import CricketASPTable from "./cricketASPTable";
import X01ASPTable from "./x01ASPTable";
import HalvesTable from "./halveTable";
import SetsTable from "./setsTable";
import { useNavigate } from "react-router";
import fonts from "../../theme/fonts";
import colors from "../../theme/colors";
import { useContext, useState } from "react";
import { OnlineMatchContext } from "../../contexts/OnlineMatchContext";

interface ResultScreenProps {
  matchState: BaseMatchState;
  newGameHandler: Function;
  rematchHandler: Function;
}

export default function ResultScreen({
  matchState,
  newGameHandler,
  rematchHandler,
}: ResultScreenProps) {
  const navigate = useNavigate();
  const { online, handleContinueGame, handleRestartGame } =
    useContext(OnlineMatchContext);
  const [clickedContinue, setClickedContinue] = useState(false);
  const [clickedRestart, setClickedRestart] = useState(false);
  const { gameType, completed } = matchState;
  const lastLegWinner = completed.legs[completed.legs.length - 1]?.winner;
  const lastSetsLegWinner =
    completed.sets[completed.sets.length - 1]?.legs[
      completed.sets[completed.sets.length - 1].legs.length - 1
    ]?.winner;
  const winner = lastLegWinner ?? lastSetsLegWinner;
  const onContinueClick = () => {
    setClickedContinue(true);
    if (!online) {
      newGameHandler();
    } else {
      handleContinueGame();
    }
  };

  const onRestartClick = () => {
    setClickedRestart(true);
    if (!online) {
      rematchHandler();
    } else {
      handleRestartGame();
    }
  };

  return winner ? (
    <Wrapper>
      {gameType !== GAME_TYPE.HALVES && (
        <SetRow>
          <SetsTable matchState={matchState} />
        </SetRow>
      )}
      <BottomRow>
        <ASPTableWrapper>
          {gameType === GAME_TYPE.CRICKET && (
            <CricketASPTable matchState={matchState} />
          )}
          {gameType === GAME_TYPE.X01 && (
            <X01ASPTable matchState={matchState} />
          )}
          {gameType === GAME_TYPE.HALVES && (
            <HalvesTable matchState={matchState} />
          )}
        </ASPTableWrapper>
        <ButtonsWrapper>
          {matchState.matchState !== MATCH_STATE.FINISHED &&
            matchState.gameType !== GAME_TYPE.HALVES && (
              <Box>
                <SideButton
                  disabled={clickedContinue}
                  style={{ backgroundColor: "#1B4F2D" }}
                  variant="contained"
                  onClick={onContinueClick}
                >
                  Continue
                </SideButton>
              </Box>
            )}
          <Box>
            <SideButton
              disabled={clickedRestart}
              style={{ backgroundColor: "#881918" }}
              variant="contained"
              onClick={onRestartClick}
            >
              Restart
            </SideButton>
          </Box>
          <Box>
            <SideButton
              style={{ backgroundColor: "#881918" }}
              variant="contained"
              onClick={() => navigate("/", { state: { restart: true } })}
            >
              Home
            </SideButton>
          </Box>
        </ButtonsWrapper>
      </BottomRow>
    </Wrapper>
  ) : null;
}

const Wrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100vw",
  height: "100%",
  gap: "50px",
  paddingTop: "2.5%",
});

const SetRow = styled(Box)({
  display: "flex",
  justifyContent: "center",
});

const BottomRow = styled(Box)({
  display: "flex",
  justifyContent: "center",
  gap: "100px",
  flexDirection: "row",
  margin: "0 3%",
  "@media(max-width: 700px)": {
    flexDirection: "column-reverse",
    gap: "50px",
  },
});

const SideButton = styled(Button)({
  width: "150px",
  textTransform: "none",
  fontFamily: fonts.family.nice,
  fontSize: fonts.size.medium,
  "@media(max-width: 700px)": {
    width: "100px",
  },
});

const ASPTableWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  fontFamily: fonts.family.chalk,
  fontSize: fonts.size.mediumLarge,
  color: colors.lightBeige,
});

const ButtonsWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  justifyContent: "center",
  "@media(max-width: 700px)": {
    flexDirection: "row",
  },
});
